import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../_services';
import { NgxSpinnerService } from 'ngx-spinner';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, RouterEvent } from '@angular/router';
/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  submitted = false;
  showerror: number;
  messageErrorReset: any;
  messageSuccessReset: any;
  loading: boolean =false;
  constructor(  private formBuilder: FormBuilder,private spinner: NgxSpinnerService,
    private http: HttpClient,
    private authenticationService: AuthenticationService,private router: Router) { }
    matcher = new MyErrorStateMatcher();

    resetPasswordForm: FormGroup = this.formBuilder.group({

      password : [, { validators: [Validators.required], updateOn: "change" }],
      passwordConfirm: [, { validators: [Validators.required], updateOn: "change" }],

  

    },{
      validators: ConfirmedValidator('password', 'passwordConfirm')
    })
    password = new FormControl('', [
      Validators.required,
      Validators.email,
    ]);

  ngOnInit(): void {
 
    console.log(this.router.url.split("/")[3]);
  }

  onSubmit() {

    if (this.resetPasswordForm.invalid) {
      console.log(this.resetPasswordForm.invalid)
      return;
  }
  var token =this.router.url.split("/")[3]
  var password = (<HTMLInputElement>document.getElementById('password')).value
  console.log(password ,token)
  this.loading = true;
  this.spinner.show();
    this.http.post(environment.apiUrl+'/users/password/reset', {password, token}).subscribe(data => {
      
    console.log(data)

    console.log(data)
    var resp:any = data
 
   
    if(resp.status ==500){
      this.showerror =500
     this.messageErrorReset = resp.message
     this.loading = false;
this.spinner.hide();

  }else {
      this.showerror =200
      this.messageSuccessReset = resp.message
      this.loading = false;
      this.spinner.hide();
  }


    })
  }
}
export function ConfirmedValidator(controlName: string, matchingControlName: string){
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}